import { render, staticRenderFns } from "./ChanceDialogComponent.vue?vue&type=template&id=43f91e33&scoped=true"
import script from "./ChanceDialogComponent.vue?vue&type=script&lang=js"
export * from "./ChanceDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f91e33",
  null
  
)

export default component.exports